export const ARRIVE_DEPART_ROUTES = Object.freeze({
	ARRIVALS_DEPARTURE: '/arrivals-departures',
});
